import { Navigate, useLocation } from "react-router";

export const LoginRedirect = () => {
  const location = useLocation();

  return (
    <Navigate
      replace
      to="/login"
      state={{ returnTo: location.pathname + location.search }}
    />
  );
};
